import Vue from "vue";
import Router from "vue-router";
import Login from "@/views/Login";
import NotFound from "@/views/NotFound";
import Clients from "@/views/Clients";
import Client from "@/views/Client";
import ClientSyncsList from "@/views/ClientSyncsList";
import FormClient from "@/views/FormClient";
import Import from "@/views/Import";
import ImportErrorRow from "@/views/ImportErrorRow";
import FormImport from "@/views/FormImport";
import Projects from "@/views/Projects";
import Project from "@/views/Project";
import FormProject from "@/views/FormProject";
import ActivityFeeds from "@/views/ActivityFeeds";
import Settings from "@/views/Settings";
import FormTemplate from "@/views/FormTemplate";
import Contact from "@/views/Contact";
import FormContact from "@/views/FormContact";
import Form from "@/views/Form";
import FormSubmission from "@/views/FormSubmission";
import Template from "@/views/Template";
import TemplateSnippet from "@/views/TemplateSnippet";
import FormTemplateSnippet from "@/views/FormTemplateSnippet";
import TeamSubscription from "@/views/TeamSubscription";
import Library from "@/views/Library";
import FormSignedDocument from "@/views/FormSignedDocument";
import Dashboard from "@/views/Dashboard";
import Inbox from "@/views/Inbox";
import QuickLaunch from "@/views/QuickLaunch";

// swallow errors --> https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/notfound",
      name: "NotFound",
      component: NotFound,
      meta: { requiresAuth: false },
    },
    {
      path: "/login",
      name: "StaticLogin",
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: "/:teamSlug?",
      name: "Login",
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: "/:teamSlug/pwexpired",
      name: "PwExpired",
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: "/:teamSlug/pinrequest",
      name: "PinRequest",
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: "/:teamSlug/pwreset",
      name: "PwReset",
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: "/:teamSlug/totpcheck",
      name: "TotpCheck",
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: "/t/:team",
      redirect: (to) => {
        const { params } = to;
        return { name: "Dashboard", params: { team: params.team } };
      },
    },
    {
      path: "/t/:team/subscription",
      name: "TeamSubscription",
      component: TeamSubscription,
      props: true,
      meta: { requiresAuth: false },
    },
    {
      path: "/t/:team/dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/inbox",
      name: "Inbox",
      component: Inbox,
      meta: { requiresAuth: true, hideSupportBtn: true },
    },
    {
      path: "/t/:team/quicklaunch/c/:client/p/:project",
      name: "QuickLaunchWithClientAndProject",
      component: QuickLaunch,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/quicklaunch/c/:client",
      name: "QuickLaunchWithClient",
      component: QuickLaunch,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/quicklaunch",
      name: "QuickLaunch",
      component: QuickLaunch,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/clients",
      name: "Clients",
      component: Clients,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/clients/clientsyncslist",
      name: "ClientSyncsList",
      component: ClientSyncsList,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/clients/create",
      name: "createClient",
      component: FormClient,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/import/create",
      name: "createImport",
      component: FormImport,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/import/:uid",
      name: "Import",
      component: Import,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/import/:uid/error/:err",
      name: "ImportErrorRow",
      component: ImportErrorRow,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/clients/:uid",
      name: "Client",
      component: Client,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/clients/:uid/edit",
      name: "editClient",
      component: FormClient,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/projects",
      name: "Projects",
      component: Projects,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/projects/create",
      name: "createProject",
      component: FormProject,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/projects/:uid",
      redirect: (to) => {
        const { params } = to;
        return {
          name: "Project",
          params: { team: params.team, uid: params.uid, tab: "overview" },
        };
      },
    },
    {
      path: "/t/:team/projects/:uid/signeddocuments/create",
      name: "createSignedDocument",
      component: FormSignedDocument,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/projects/:uid/:tab/:subtab?",
      name: "Project",
      component: Project,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (
          [
            "overview",
            "data",
            "share",
            "uploads",
            "forms",
            "settings",
            "extended-data",
            "history",
            "fileapproval",
          ].indexOf(to.params.tab) < 0
        ) {
          next("/t/" + to.params.team + "/projects/" + to.params.uid + "/overview");
        } else if (to.params.tab === "history") {
          if (
            [
              "all",
              "fileuploads",
              "filedownloads",
              "filepreviews",
              "pageviews",
              "projectmessages",
              "projectfilesignings",
            ].indexOf(to.params.subtab) < 0
          ) {
            next("/t/" + to.params.team + "/projects/" + to.params.uid + "/history/all");
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/t/:team/activity/:tab",
      name: "ActivityFeeds",
      component: ActivityFeeds,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (
          [
            "all",
            "fileuploads",
            "filedownloads",
            "pageviews",
            "projectmessages",
            "projectfilesignings",
            "abonnements",
          ].indexOf(to.params.tab) < 0
        ) {
          next("/t/" + to.params.team + "/activity/all");
        } else {
          next();
        }
      },
    },
    {
      path: "/t/:team/settings",
      redirect: (to) => {
        const { params } = to;
        return {
          name: "Settings",
          params: { team: params.team, tab: "account" },
        };
      },
    },
    {
      path: "/t/:team/settings/:tab?",
      name: "Settings",
      component: Settings,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (["account", "team", "contacts", "templates", "forms", "imports", "developer"].indexOf(to.params.tab) < 0) {
          next("/t/" + to.params.team + "/settings/account");
        } else {
          next();
        }
      },
    },
    {
      path: "/t/:team/settings/forms/:uid",
      name: "Form",
      component: Form,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/settings/forms/:form/submission/:submission",
      name: "FormSubmission",
      component: FormSubmission,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/settings/templates/create",
      name: "createTemplate",
      component: FormTemplate,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/settings/templates/:uid/:tab",
      name: "Template",
      component: Template,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        console.log("BEFORE ENTER", to.params.tab);
        if (!to.params.tab || to.params.tab === "") {
          next("/t/" + to.params.team + "/settings/templates/" + to.params.uid + "/_general");
        } else {
          next();
        }
      },
    },
    {
      path: "/t/:team/settings/templates/:uid/edit",
      name: "editTemplate",
      component: FormTemplate,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/settings/templates/:template/snippets/new",
      name: "createTemplateSnippet",
      component: FormTemplateSnippet,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/settings/templates/:template/snippets/:uid",
      name: "TemplateSnippet",
      component: TemplateSnippet,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/settings/templates/:template/snippets/:uid/edit",
      name: "editTemplateSnippet",
      component: FormTemplateSnippet,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/settings/contacts/create",
      name: "createContact",
      component: FormContact,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/settings/contacts/:uid",
      name: "Contact",
      component: Contact,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/settings/contacts/:uid/edit",
      name: "editContact",
      component: FormContact,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/library",
      name: "Library",
      component: Library,
      meta: { requiresAuth: true },
    },
    {
      path: "/t/:team/library/:uid",
      name: "LibraryFolder",
      component: Library,
      meta: { requiresAuth: true },
    },
  ],
});
